import React from "react";

import Spinner from "../../Component/UI/spinner/Spinner"
import classes from "./SearchP.module.css";
import Breadcrumb from "../UI/Breadcrumb/Breadcrumb";
import ListView from "./ListView/ListView";
import SearchOptions from "./SearchOptions/SearchOptions";
import GridView from "./GridView/GridView";
import Paggination from "../UI/Paggination/Paggination";
import Backdrop from "../UI/Backdrop/Backdrop";
import SideDrawer from "../UI/SideDrawer/SideDrawer";

const SearchP = (props) => {
    return (
            <div className={classes.SearchP}>
                <Backdrop
                    show={props.showBackdrop}
                    closeBackdrop={props.closeBackdrop} />
                <SideDrawer show={props.showBackdrop} reLoadCompnent={props.reLoadCompnent} />
                <Breadcrumb
                    sortBy={props.sortBy}
                    OpenDrawer={props.OpenDrawer} />
                <div className={classes.Container}>
                    {props.windoWidth > 898 ?
                        <div className={classes.OnlyBigScreen}>
                            {props.showComponent ?
                                <SearchOptions reLoadCompnent={props.reLoadCompnent} />
                                :
                                null}
                        </div>
                        :
                        null}

                    {props.itemsLoading ?
                        <div className={classes.SearchSpinners}>
                            <Spinner />
                            <Spinner />
                            <Spinner />
                        </div>
                        :
                        props.viewType === 'list' ?
                            <ListView
                                listVehicleItems={props.vehicleItems}
                                routProp={props.routerProps}
                                user={props.user}
                                wishIdsArray={props.wishIdsArray}
                                showAuthHandler={props.showAuthHandler}
                                AddItemToWishList={props.AddItemToUserWishList}
                                addingItem={props.addingItem} /> :
                            <GridView
                                girdVehicleItems={props.vehicleItems}
                                routProp={props.routerProps}
                                user={props.user}
                                wishIdsArray={props.wishIdsArray}
                                showAuthHandler={props.showAuthHandler}
                                AddItemToWishList={props.AddItemToUserWishList}
                                addingItem={props.addingItem} />
                    }
                </div>
                <Paggination paggination={props.vehicleItems} brand={props.brand} />
            </div>
    );
}



export default SearchP;